import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IntersectSquare = function IntersectSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 2 4.08 2 5.2 2h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C16 3.5198 16 4.08 16 5.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C14.4802 16 13.9201 16 12.8 16H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.4802 2 13.9201 2 12.8z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8 11.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C9.5198 8 10.08 8 11.2 8h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874.218.4278.218.988.218 2.108v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 22 19.9201 22 18.8 22h-7.6c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C8 20.4802 8 19.9201 8 18.8z"
    })]
  }));
};
export default IntersectSquare;